import { FC } from 'react';

import { IndexPage as Index } from '@tnmw/static-pages';

const IndexPage: FC = () => {
  return (
    <>
      <Index />
    </>
  );
};

export default IndexPage;
